import React from 'react'
import { connect } from 'react-redux'
import { A, Button } from '@driftt/tide-core-legacy'
import { FeatureTooltip } from '@driftt/tide-tooltips-legacy'
import { updateUserProperties } from 'app/modules/user/properties/actions'
import * as UserSelectors from 'app/modules/user/selectors'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'

const USER_PROPERTY_KEY = 'hasDismissedPlaybooksReportButtonTooltip'

const getPlaybookReportPath = (activeTab) => {
  if (activeTab === 'CHAT') {
    return '/reports/chat-playbooks'
  }
  if (activeTab === 'EMAIL') {
    return '/reports/email-playbooks'
  }
  if (activeTab === 'SEQUENCE') {
    return '/reports/sales-sequences'
  }
}

const PlaybooksReportButton = ({ activeTab, showTooltip, updateUserProperties }) => (
  <div className="playbooks-table-toolbar-reports-button-container" onClick={updateUserProperties}>
    <FeatureTooltip
      headerCopy="Access your metrics here!"
      bodyCopy="Measure performance across playbooks in this report."
      className="playbooks-table-reports-button-tooltip"
      onClose={updateUserProperties}
      ribbonType="new"
      showTooltip={showTooltip}
      tooltipSide="bottom"
      tooltipCaretLocation="right"
    >
      <A href={getPlaybookReportPath(activeTab)}>
        <Button type="tertiary" className="playbooks-table-toolbar-reports-button" icon="bar-chart">
          Reports
        </Button>
      </A>
    </FeatureTooltip>
  </div>
)

const mapStateToProps = state => {
  const userProperties = UserPropertiesSelectors.properties(state)
  const currentUser = UserSelectors.currentUser(state)
  const wasUserCreatedBeforeIntroduction = currentUser.createdAt < 1561766400000 // new Date('2019-06-29').getTime()

  return {
    showTooltip: wasUserCreatedBeforeIntroduction && !userProperties.get(USER_PROPERTY_KEY),
  }
}

const mapDispatchToProps = dispatch => ({
  updateUserProperties: () => dispatch(updateUserProperties({
    notify: false,
    properties: {
      [USER_PROPERTY_KEY]: true,
    },
  }))
})

export default connect(mapStateToProps, mapDispatchToProps)(PlaybooksReportButton)


// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/PlaybooksReportButton/index.js